import { render, staticRenderFns } from "./roam-bin-movement-list.vue?vue&type=template&id=6a65443c&"
import script from "./roam-bin-movement-list.vue?vue&type=script&lang=js&"
export * from "./roam-bin-movement-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports